import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GdAvatarPage } from './gd-avatar';
import { ImageComponentModule } from '../image-component/image-component.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    GdAvatarPage,
  ],
  imports: [
    IonicPageModule.forChild(GdAvatarPage),
    ImageComponentModule,
    FlexLayoutModule,
    DirectivesModule
  ],
  exports: [
    GdAvatarPage
  ]
})
export class GdAvatarPageModule {}



// WEBPACK FOOTER //
// ./src/components/gd-avatar/gd-avatar.module.ts